import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth-service/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false,
})
export class AuthComponent implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  authenticating = true;
  private readonly subscriptions: Subscription[];

  constructor() {
    this.subscriptions = [];
  }

  ngOnInit() {
    this.subscriptions.push(
      this.authService.onTokenReceived.subscribe(() => {
        this.router.navigateByUrl('login');
      })
    );
    this.subscriptions.push(
      this.authService.onError.subscribe(() => {
        this.authenticating = false;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
